import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPen } from "@fortawesome/free-solid-svg-icons";
import { useTranslation } from "react-i18next";
import { Field as BaseField } from "rc-field-form";
import { Input } from "reactstrap";
import Field from "../../../../../../../../../components/Field";
import Checkbox from "../../../../../../../../../components/Inputs/Checkbox";
import Modal from "../../../../../../../../../components/Modal";
import Details from "./Details";
import { useVisible } from "../../../../../../../../../utils/hooks/useVisible";

const getFieldName = (name) => ["guarantee", "daily-guarantee", name];

function DailyGuarantee({ disabled }) {
	const { t } = useTranslation();

	const { visible, open, close } = useVisible();

	return (
		<div className="guarantee-rule">
			<div className="d-flex align-items-center w-100">
				<Field
					name={getFieldName("status")}
					valuePropName="checked"
					noStyle
					className="mb-0"
				>
					<Checkbox id="daily-guarantee">
						{t("daily-guarantee")}
					</Checkbox>
				</Field>
			</div>

			<BaseField noStyle shouldUpdate>
				{({ }, { }, { getFieldValue, getFieldError }) => {
					const data = getFieldValue([
						"guarantee",
						"daily-guarantee",
					]);

					const status = data.status;
					const error = getFieldError(getFieldName("value"));

					return (
						<>
							<div className="d-flex align-items-center">
								<BaseField
									name={getFieldName("dayCountType")}
									hidden
								/>

								<BaseField
									name={getFieldName("weekdays")}
									hidden
								/>

								<BaseField
									name={getFieldName("dayCount")}
									hidden
								/>

								<BaseField
									name={getFieldName("duration")}
									hidden
								/>

								<BaseField
									name={getFieldName("initializeByClock")}
									hidden
								/>

								<BaseField
									name={getFieldName("baseOnExpectedHours")}
									hidden
								/>

								<BaseField
									name={getFieldName("minWorkedDuration")}
									hidden
								/>

								<BaseField
									name={getFieldName("includeWorkedDuration")}
									hidden
								/>

								<BaseField
									name={getFieldName("cap")}
									hidden
								/>

								<BaseField
									name={getFieldName("payCode")}
									hidden
								/>

								<BaseField
									name={getFieldName("start")}
									hidden
								/>

								<BaseField
									name={getFieldName("hourTypes")}
									hidden
								/>

								<BaseField
									name={getFieldName("payCodes")}
									hidden
								/>
							</div>

							<div className="d-flex align-items-center justify-content-end">
								<FontAwesomeIcon
									className="text-sm cursor-pointer"
									icon={faPen}
									onClick={status ? open : undefined}
								/>
							</div>

							{error && (
								<span className="invalid-feedback d-block">
									{error[0]}
								</span>
							)}

							<Modal
								title={t("daily-guarantee-rule-parameters")}
								isOpen={visible}
								close={close}
								centered={true}
								size="lg"
								scrollable={true}
							>
								<Details
									close={close}
									guarantee={data}
									disabled={disabled}
								/>
							</Modal>
						</>
					);
				}}
			</BaseField>
		</div>
	);
}

export default DailyGuarantee;
